<ng-container *ngIf="data">
  {{ getName(data) }}
</ng-container>
<ng-container *ngIf="!data">
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-container>
